import React, { useState } from "react";
import { Box, IconButton } from "@mui/material";
import ViewListIcon from "@mui/icons-material/ViewList";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import AppsIcon from "@mui/icons-material/Apps";

const ViewModeSwitcher = ({ viewMode, onViewChange }) => {
  const handleViewChange = (mode) => {
    console.log(`Switching to mode: ${mode}`); // Логируем нажатие
    if (onViewChange) {
      onViewChange(mode); // Уведомляем родителя, если передан callback
    } else {
      console.log("No onViewChange callback provided"); // Логируем отсутствие callback
    }
  };

  return (
    <Box>
      <IconButton onClick={() => handleViewChange("list")}>
        <ViewListIcon color={viewMode === "list" ? "primary" : "inherit"} />
      </IconButton>
      <IconButton onClick={() => handleViewChange("module")}>
        <ViewModuleIcon color={viewMode === "module" ? "primary" : "inherit"} />
      </IconButton>
      <IconButton onClick={() => handleViewChange("apps")}>
        <AppsIcon color={viewMode === "apps" ? "primary" : "inherit"} />
      </IconButton>
    </Box>
  );
};

export default ViewModeSwitcher;
